(function () {
  'use strict';

  const escapeHtml = value => String(value).replace(/[&<>"']/g, char =>
    ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char]);
  const normalize = value => String(value || '').normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '').toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ').trim();
  const shortName = value => normalize(value)
    .replace(/^nous tous /, '')
    .replace(/\b(?:elixir de parfum|eau de parfum|discovery set)\b/g, '')
    .trim();

  function findByName(value, catalog) {
    const name = shortName(value);
    if (!name) return null;
    return catalog.find(item => {
      const title = shortName(item.title);
      return title.length >= 4 && (name === title || name.startsWith(title + ' '));
    }) || null;
  }

  function handleFromUrl(value) {
    try {
      const url = new URL(value.startsWith('products/') ? '/' + value : value, location.origin);
      if (!['http:', 'https:'].includes(url.protocol)) return null;
      if (url.origin !== location.origin && !/^(?:www\.)?nutu\.store$/i.test(url.hostname)) return null;
      const match = url.pathname.match(/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/([a-z0-9-]+)\/?$/i);
      return match ? match[1].toLowerCase() : null;
    } catch (_) { return null; }
  }

  function render(raw, catalog, root) {
    raw = String(raw || '');
    catalog = Array.isArray(catalog) ? catalog.filter(item => item && /^[a-z0-9-]+$/i.test(item.handle || '')) : [];
    root = String(root || '/');
    if (!root.endsWith('/')) root += '/';
    const slots = [];
    const linked = new Set();
    const token = html => {
      const index = slots.push(html) - 1;
      return '\uE000' + index + '\uE001';
    };
    const productCard = (handle, label) => {
      const known = catalog.find(item => item.handle === handle);
      const named = findByName(label, catalog);
      const item = named || known;
      const actualHandle = item ? item.handle : handle;
      if (!/^[a-z0-9-]+$/i.test(actualHandle)) return escapeHtml(label);
      linked.add(actualHandle);
      return '<div class="nt-rich-link-wrapper"><a class="nt-rich-link" data-handle="' +
        escapeHtml(actualHandle) + '" href="' + escapeHtml(root + 'products/' + actualHandle) +
        '"><span class="nt-rich-title">' + escapeHtml(item?.title || label || actualHandle) +
        '</span><span aria-hidden="true">↗</span></a></div>';
    };
    let output = raw
      .replace(/\[\[PRODUCT:([a-z0-9-]+)(?:\|([^\]\n]+))?\]\]/gi, (_, handle, label) =>
        token(productCard(handle.toLowerCase(), label || handle)))
      .replace(/(?:👉\s*)?\[([^\]\n]+)\]\(([^\s)]+)\)/g, (match, label, path) => {
        const handle = handleFromUrl(path);
        if (handle) return token(productCard(handle, label));
        try {
          const url = new URL(path, location.origin);
          if (!['http:', 'https:'].includes(url.protocol)) return label;
          return token('<a href="' + escapeHtml(url.href) + '" rel="noopener noreferrer"' +
            (url.origin !== location.origin ? ' target="_blank"' : '') + '>' + escapeHtml(label) + '</a>');
        } catch (_) { return label; }
      })
      .replace(/(?:https?:\/\/(?:www\.)?nutu\.store)?\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[a-z0-9-]+(?:\?[^\s<]*)?/gi, match => {
        const handle = handleFromUrl(match.replace(/[.,;!?]+$/, ''));
        return handle ? token(productCard(handle, handle)) : match;
      });
    output = escapeHtml(output).replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
      .replace(/~~(.+?)~~/g, '<del>$1</del>').replace(/\n/g, '<br>')
      .replace(/\uE000(\d+)\uE001/g, (_, index) => slots[Number(index)]);

    // Some advisor replies contain only product names. Add verified catalog cards
    // for recommendation headings rather than inventing a URL from the name.
    const additions = [];
    for (const line of raw.split('\n')) {
      const heading = line.replace(/^\s*(?:[-*•]\s*|\d+[.)]\s*|👉\s*)+/, '')
        .replace(/\*\*/g, '').split(/\s*(?::|[—–]| - )\s*/)[0].trim();
      const item = findByName(heading, catalog);
      if (item && !linked.has(item.handle)) additions.push(productCard(item.handle, item.title));
      if (additions.length >= 4) break;
    }
    if (!linked.size) {
      const mentioned = catalog.map(item => ({ item, index: normalize(raw).indexOf(shortName(item.title)) }))
        .filter(entry => entry.index >= 0).sort((a, b) => a.index - b.index);
      for (const { item } of mentioned) {
        if (!linked.has(item.handle)) additions.push(productCard(item.handle, item.title));
        if (additions.length >= 3) break;
      }
    }
    return output + (additions.length ? '<div class="nt-recommended-products">' + additions.join('') + '</div>' : '');
  }

  window.NTAdvisorProductLinks = { render, findByName, handleFromUrl };
})();
